import { Component } from '@angular/core';
import { BasePage } from '@shared-pages/base.page';

@Component({
	selector: 'clients-page',
	templateUrl: 'clients.page.html',
})
export class ClientsPage extends BasePage {
	constructor() {
		super();
	}
}
